/**
 * Browser stand-in for Node's `stream` module.
 *
 * `@aws-sdk/lib-storage`'s `chunker.js` unconditionally imports `Readable`
 * from `stream` just to run `instanceof Readable` against the upload body —
 * it never needs real Node stream behavior in this app, since every upload
 * body here is a browser `Blob`/`File`, never a Node `Readable`. Aliased in
 * from `vite.config.mjs` so that check simply evaluates `false` instead of
 * pulling in `stream-browserify` -> `readable-stream`, whose
 * `_stream_readable.js` does a bare `require('util')` that Rolldown's browser
 * build has nothing to resolve against:
 *   Uncaught Error: Calling `require` for "util" in an environment that
 *   doesn't expose the `require` function.
 */
export class Readable {}
